import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FindPollingStationForm from './FindPollingStationForm';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import { cacheFormData } from '../../utils/formCaching/actions';

import { submitFindPollingStationForm } from '../../containers/FindPollingStation/actions';

import {
    AnimationContainer,
    ContainerAbsolute,
    Body
} from '../../containers/DefaultStyles/AssessmentDetails';

const AddressPopup = props => (
    <AnimationContainer>
        <ContainerAbsolute>
            <Body>
                <FindPollingStationForm
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.submitFindPollingStationForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime()
                        );
                    }}
                    onBack={props.onBack}
                    isAddressSubmitting={props.isAddressSubmitting}
                />
            </Body>
        </ContainerAbsolute>
    </AnimationContainer>
);

AddressPopup.propTypes = {
    submitFindPollingStationForm: PropTypes.func.isRequired,
    isAddressSubmitting: PropTypes.bool,
    onBack: PropTypes.func,
    apiRequestData: PropTypes.object.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        return {
            apiRequestData: state.widget.apiRequestData,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            actionCompletedTime: getActionCompletedTime(state, 'findPollingStation'),
            isAddressSubmitting: state.findPollingStation.isAddressSubmitting
        };
    },
    {
        submitFindPollingStationForm,
        cacheFormData
    }
)(AddressPopup);



// WEBPACK FOOTER //
// ./src/components/FindPollingStation/AddressPopup.jsx